import s from "./AccountPage.module.scss";
import avatarImg from "..//..//icons/avatar.png";
import cameraIcon from "./cameraIcon.svg";
import classNames from "classnames";
import { useEffect, useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { DeleteAccountModal } from "./DeleteAccountModal";
import { useForm, useFieldArray } from "react-hook-form";
import { formatDate } from "utils/utils";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { Resolver } from "react-hook-form";
import minus from "../CreateEvent/Images/minus.png";
import { API_BASE } from "config/api";
import * as yup from "yup";

// Схема валидации формы

const schema = yup.object().shape({
  name: yup.string().required("Имя обязательно").min(2, "Минимум 2 символа"),
  email: yup.string().required("Email обязателен").email("Некорректный email"),
  phone_number: yup
    .string()
    .transform((value, originalValue) => {
      return originalValue ? originalValue.replace(/[^\d+]/g, "") : value;
    })
    .test(
      "phone-format",
      "Некорректный номер (формат: +7XXXXXXXXXX или 8XXXXXXXXXX)",
      (value) => {
        if (!value) return true;
        return /^(\+7|8)\d{10}$/.test(value);
      }
    )
    .notRequired(),
  description: yup.string().max(500, "Максимум 500 символов").notRequired(),

  social_media_links: yup
    .array()
    .of(
      yup.object().shape({
        url: yup.string().url("Некорректный URL").required("Обязательное поле"),
      })
    )
    .notRequired(),
  avatar_upload: yup.mixed().notRequired(),
  agree: yup.boolean().oneOf([true], "Требуется согласие").notRequired(),
});

// Интерфейс значений формы

interface FormValues {
  name: string;
  email: string;
  phone_number?: string;
  description?: string;
  avatar_upload?: string;
  social_media_links: Array<{ url: string }>;
  agree?: boolean;
}

// Интерфейс для полей ввода

// interface InputField {
//   id: number;
//   value: string;
// }

// Интерфейс для событий

interface Event {
  id: number;
  name: string;
  is_finished: boolean;
  is_canceled: boolean;
  starts_at: string;
  ends_at: string;
  cover_medium: string;
  place?: {
    name: string;
    city: string;
    address: string;
  };
  price_min: number;
}

// Категории событий

const eventCategories = ["Все", "Завершённые", "Ожидается"];

// Компонент страницы аккаунта

export const AccountPage: React.FC = () => {
  // const { avatar, handleFileChange } = useOutletContext<ContextType>();
  // const [issocialAdd, setIssocialAdd] = useState<InputField[]>([]); //состояние для добавление соцсети
  const [isMarginBottomAdded, setMarginBottomAdded] = useState(false); // состояние для обработки ипутов соцсетей

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [events, setEvents] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [avatar, setNewAvatar] = useState<string>("");

  // Состояния об уведомлении обнов. данных
  // const [showToast, setShowToast] = useState(false);
  // const [toastMessage, setToastMessage] = useState("");

  // Состояние для отслеживания статуса сохранения
  const [isSaving, setIsSaving] = useState(false);
  const saveTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Состояние для отслеживания выбранной категории
  const [selectedCategory, setSelectedCategory] = useState("Все");

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    control,
    trigger,
    setValue,
    reset,
    watch,
    formState: { errors, isDirty: formIsDirty },
  } = useForm<FormValues>({
    resolver: yupResolver(schema) as Resolver<FormValues>,
    defaultValues: {
      name: "",
      email: "",
      phone_number: "",
      description: "",
      social_media_links: [{ url: "" }, { url: "" }],
    },
  });

  const descriptionValue = watch("description");
  const descriptionRegister = register("description");

  const { fields, append, remove } = useFieldArray({
    control,
    name: "social_media_links",
  });

  const getAuthToken = (): string | null => {
    const cookies = document.cookie;
    const cookiesArray = cookies.split(";");
    for (const cookie of cookiesArray) {
      const [name, value] = cookie.trim().split("=");
      if (name === "authToken") {
        return value;
      }
    }
    return null;
  };

  useEffect(() => {
    if (!getAuthToken()) {
      navigate("/registrationPage");
    }
  }, [navigate]);

  // Обработка отправки формы

  const onSubmit = async (formDataValues: FormValues) => {
    const token = getAuthToken();
    if (!token) {
      console.error("Токен не найден");
      return;
    }

    // Очистка ссылок на социальные сети
    const cleanedLinks = (formDataValues.social_media_links || [])
      .map((l) => (l?.url || "").trim())
      .filter((u) => u.length > 0)
      .map((url) => ({ url }));

    // Получаем ID из локального хранилища
    const userId = localStorage.getItem("userId");

    if (!userId) {
      console.error("ID пользователя не найден");
      return;
    }

    const trimmedDescription = formDataValues.description?.trim() ?? "";

    const payload = {
      first_name: formDataValues.name?.trim(),
      phone_number: formDataValues.phone_number?.trim() || undefined,
      description: trimmedDescription,
      social_media_links: cleanedLinks,
    };

    const avatarFile = fileInputRef.current?.files?.[0];

    if (avatarFile) {
      const avatarData = new FormData();
      avatarData.append("avatar", avatarFile);
    }

    try {
      if (!formIsDirty) return;

      setIsSaving(true);
      const res = await fetch(`${API_BASE}/users/update/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
        credentials: "include",
      });

      if (res.ok) {
        const result = await res.json();
        console.log("Профиль обновлен:", result);

        if (result?.id != null) {
          localStorage.setItem("userId", String(result.id));
        }

        localStorage.setItem(
          "userName",
          result.first_name || formDataValues.name
        );
        setValue("name", result.first_name || formDataValues.name);
        reset({
          name: result.first_name,
          email: formDataValues.email,
          phone_number: formDataValues.phone_number || "",
          description: formDataValues.description || "",
          social_media_links: result.social_media_links?.length
            ? result.social_media_links
            : [{ url: "" }],
        });

        if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
        saveTimeoutRef.current = setTimeout(() => {
          setIsSaving(false);
        }, 2000);
      } else {
        console.error("Ошибка при сохранении профиля:", res.status);
      }
    } catch (error) {
      setIsSaving(false);
      console.error("Ошибка при отправке данных профиля:", error);
    }
  };

  const fetchProfile = useCallback(async () => {
    const token = getAuthToken();
    if (!token) {
      console.error("Токен не найден");
      return;
    }

    const userId = localStorage.getItem("userId");
    if (!userId) {
      console.error("ID пользователя не найден");
      return;
    }

    // Получаем профиль пользователя
    try {
      const res = await fetch(`${API_BASE}/users/profile/${userId}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include",
      });

      if (res.ok) {
        const data = await res.json();
        console.log("Данные пользователя:", data);
        // setNewAvatar(data.avatar.medium);
        setNewAvatar(data.avatar?.medium || "");
        localStorage.setItem("avatar", data.avatar?.medium);

        reset({
          name: data.first_name,
          email: data.email,
          phone_number: data.phone_number,
          description: data.description,
          social_media_links: data.social_media_links?.length
            ? data.social_media_links
            : [{ url: "" }],
          // social_media_links: data.social_media_links || [],
        });
      } else {
        console.error("Ошибка при получении данных пользователя:", res.status);
      }
    } catch (error) {
      console.error("Ошибка при запросе данных профиля:", error);
    }
  }, [reset, setNewAvatar]);

  // Обработчик изменения аватара

  const handleAvatarChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("avatar_upload", file);

    try {
      const res = await fetch(`${API_BASE}/users/update/`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
        body: formData,
      });

      if (res.ok) {
        const data = await res.json();
        setNewAvatar(data.avatar.medium);
        localStorage.setItem("avatar", data.avatar.medium);
        await fetchProfile();
      } else {
        console.error("Ошибка загрузки:", await res.json());
      }
    } catch (error) {
      console.error("Ошибка сети:", error);
    }
  };

  // Обработчик удаления аккаунта

  const handleDeleteAccount = async (data: {
    reason: string;
    other_reason?: string;
  }) => {
    const token = getAuthToken();
    const userId = localStorage.getItem("userId");

    if (!token || !userId) {
      console.error("Аутентификация не пройдена");
      return;
    }

    try {
      const response = await fetch(`${API_BASE}/users/delete/${userId}/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setNewAvatar(avatarImg);
        localStorage.setItem("avatar", avatarImg);
        localStorage.clear();
        // Удаление куки с токеном
        document.cookie =
          "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        navigate("/");

        // window.location.href = "/";
      } else {
        console.error("Ошибка удаления:", await response.text());
      }
    } catch (error) {
      console.error("Ошибка сети:", error);
    }
  };

  // Получаем профиль пользователя

  useEffect(() => {
    // Запуск валидации
    trigger(["name", "email", "phone_number", "description"]);

    // Запрашиваем актуальные данные пользователя с сервера
    fetchProfile();
  }, [setValue, trigger, fetchProfile]);

  //состояние для переключателя создано/куплено
  const [selectedEventsType, setSelectedEventsType] = useState<
    "created" | "bought"
  >("created");

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const handleAccountImageClick = () => {
    fileInputRef.current?.click();
  };

  const descriptionRef = useRef<HTMLTextAreaElement | null>(null);

  const BASE_TEXTAREA_HEIGHT = 36;

  const autoResize = (element: HTMLTextAreaElement | null) => {
    if (!element) return;

    element.style.height = `${BASE_TEXTAREA_HEIGHT}px`;

    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;

    if (scrollHeight > clientHeight) {
      element.style.height = `${scrollHeight}px`;
    }
  };

  useEffect(() => {
    autoResize(descriptionRef.current);
  }, [descriptionValue]);

  useEffect(() => {
    setMarginBottomAdded(true);
    //очистка таймера для кнопки сохранить
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }
  }, []);
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setIsLoading(true);
        const authToken = getAuthToken();

        const endpoint =
          selectedEventsType === "created"
            ? `${API_BASE}/events/my/`
            : `${API_BASE}/tickets/my-events/`;

        const response = await fetch(endpoint, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) throw new Error("Ошибка загрузки");

        const data = await response.json();

        // Фильтрация на клиенте
        let filteredEvents = data.results;
        if (selectedCategory === "Завершённые") {
          filteredEvents = data.results.filter(
            (event: Event) => event.is_finished
          );
        } else if (selectedCategory === "Ожидается") {
          const now = new Date();
          filteredEvents = data.results.filter(
            (event: Event) =>
              new Date(event.starts_at) > now && !event.is_canceled
          );
        }

        setEvents(filteredEvents);
      } catch (error) {
        console.error("Ошибка:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEvents();
  }, [selectedEventsType, selectedCategory]);

  return (
    <>
      <div className={s.main}>
        <section className={s.personDataSection}>
          <div className={s.avatarWrapp}>
            {" "}
            <h2 className={s.mob_title}>Личный кабинет</h2>
            <div className={s.accauntavatar}>
              <img
                className={s.accountAvatarImage}
                src={avatar || avatarImg}
                alt="accountAvatar"
              />

              <div
                className={s.avatarChangeIcon}
                onClick={handleAccountImageClick}
              >
                <img src={cameraIcon} alt="changeAvatarIcon" />
              </div>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleAvatarChange}
              />
            </div>
          </div>
          <div className={s.content}>
            <h2 className={s.content_title}>Личный кабинет</h2>
            <form onSubmit={handleSubmit(onSubmit)} className={s.form}>
              <div className={s.inputWrappTop}>
                <div className={s.inputWrapp}>
                  <label className={s.label}>Имя</label>
                  <input
                    className={classNames(s.input, s.nameInput)}
                    type="text"
                    {...register("name")}
                  />
                </div>{" "}
                {errors.name && (
                  <span className={s.error}>{errors.name.message}</span>
                )}
                <div className={s.inputWrapp}>
                  <label htmlFor="email" className={s.label}>
                    Email
                  </label>
                  <input
                    type="email"
                    {...register("email")}
                    className={classNames(s.input, s.emailInput)}
                  />
                </div>{" "}
                {errors.email && (
                  <span className={s.error}>{errors.email.message}</span>
                )}
                <div className={s.inputWrapp}>
                  <label htmlFor="tel" className={s.label}>
                    Телефон
                  </label>
                  <input
                    type="tel"
                    {...register("phone_number")}
                    className={classNames(s.input, s.telInput)}
                  />

                  {errors.phone_number && (
                    <p className={s.error}>{errors.phone_number.message}</p>
                  )}
                </div>
                <div className={s.input_block}>
                  <label className={s.input_label}>О себе</label>
                  <textarea
                    {...descriptionRegister}
                    className={s.input_aboutMe}
                    ref={(element: HTMLTextAreaElement | null) => {
                      descriptionRegister.ref(element);
                      descriptionRef.current = element;
                      autoResize(element);
                    }}
                  ></textarea>
                  {errors.description && (
                    <span className={s.error}>
                      {errors.description.message}
                    </span>
                  )}
                </div>
              </div>

              <div className={classNames(s.addSocialNetworkWrapp)}>
                {fields.map((field, index) => (
                  <div
                    className={classNames(
                      s.addSocialNetwork,
                      isMarginBottomAdded && s.marginBottom
                    )}
                    key={field.id} // Используем id из field
                  >
                    <div className={s.input_block}>
                      <label
                        htmlFor={`input-${field.id}`}
                        className={s.input_label}
                      >
                        Ссылка на соц. сеть
                      </label>
                      <div className={s.Input_flex}>
                        <input
                          type="text"
                          {...register(`social_media_links.${index}.url`)} // Регистрируем поле
                          className={s.input_socialNetwork}
                        />
                        {fields.length > 1 && (
                          <button
                            className={s.delButton}
                            onClick={() => remove(index)}
                            disabled={fields.length <= 1}
                          >
                            <img src={minus} alt="minus" />
                          </button>
                        )}
                      </div>
                      {errors.social_media_links?.[index]?.url && (
                        <span className={s.error}>
                          {errors.social_media_links[index]?.url?.message}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
                <button
                  className={s.addSocialBtn}
                  onClick={() => append({ url: "" })} // Используем append вместо handleAddInput
                  type="button"
                >
                  Добавить соц. сеть<span>+</span>
                </button>
              </div>
              <button
                type="submit"
                className={s.accountPageBtn}
                disabled={!formIsDirty || isSaving}
              >
                {isSaving
                  ? "Изменения сохранены"
                  : formIsDirty
                  ? "Сохранить"
                  : "Сохранить"}
                {/* {isSaving ? "Изменения сохранены" : "Сохранить"} */}
              </button>
            </form>
          </div>
        </section>
        <section className={s.myEventsSection}>
          <div className={s.myEventsSection_TabsWrapp}>
            <h2 className={s.myEventsSection_title}>Мои события</h2>

            <div className={s.tabsContainer}>
              <button
                className={classNames(
                  s.tabItem,
                  selectedEventsType === "created" && s.active
                )}
                onClick={() => setSelectedEventsType("created")}
              >
                Создано
              </button>
              <button
                className={classNames(
                  s.tabItem,
                  selectedEventsType === "bought" && s.active
                )}
                onClick={() => setSelectedEventsType("bought")}
              >
                Куплено
              </button>
            </div>
          </div>

          <div className={s.eventCategoriesWrapp}>
            {eventCategories.map((category, index) => (
              <button
                key={index}
                className={classNames(
                  s.eventCategoryBtn,
                  selectedCategory === category && s.activeCategory
                )}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
          {!isLoading && events.length === 0 && (
            <div className={s.eventEmptyCart}>
              <p className={s.eventEmptyCart_Text}>
                {selectedEventsType === "bought"
                  ? "Вы пока не купили билет на событие"
                  : "Вы пока не создали своего мероприятия"}
              </p>
              <Link
                to={selectedEventsType === "bought" ? "/" : "/createEventPage"}
              >
                <button className={s.eventEmptyCart_Btn}>
                  {selectedEventsType === "bought"
                    ? "Перейти к покупке"
                    : "Создать мероприятие"}
                </button>
              </Link>
            </div>
          )}

          {isLoading ? (
            <div>Загрузка...</div>
          ) : (
            <div className={s.eventWrapp}>
              {events.map((event) =>
                selectedEventsType === "bought" ? (
                  <Link
                    to={`/event/${event.id}`}
                    key={event.id}
                    className={s.eventCard}
                  >
                    <img
                      className={s.eventCard_image}
                      src={event.cover_medium}
                      alt="concert"
                    />

                    <div className={s.eventCard_address}>
                      <div className={s.eventCard_addressWrapp}>
                        <p className={s.eventCard_title}>{event.name}</p>
                        <p className={s.eventCardData}>
                          {event?.starts_at && formatDate(event.starts_at)}
                        </p>
                      </div>
                      <div className={s.eventCardPlace}>
                        <p>{event.place?.name} </p>
                      </div>
                    </div>

                    <button className={s.button}>{event.price_min} ₽</button>
                  </Link>
                ) : (
                  <Link
                    to={`/organizer_event/${event.id}`}
                    className={s.eventCard}
                  >
                    <img
                      className={s.eventCard_image}
                      src={event.cover_medium}
                      alt="concert"
                    />

                    <div className={s.eventCard_address}>
                      <div className={s.eventCard_addressWrapp}>
                        <p className={s.eventCard_title}>{event.name}</p>
                        <p className={s.eventCardData}>
                          {event?.starts_at && formatDate(event.starts_at)}
                        </p>
                      </div>
                      <div className={s.eventCardPlace}>
                        <p>{event.place?.name} </p>
                      </div>
                    </div>

                    <button className={s.button}>{event.price_min}</button>
                  </Link>
                )
              )}
            </div>
          )}
        </section>
        <div className={s.accountDeleteWrapp}>
          <button
            className={s.accountDelete}
            onClick={() => setIsDeleteModalOpen(true)}
          >
            Удалить аккаунт
          </button>
          <DeleteAccountModal
            isOpen={isDeleteModalOpen}
            onConfirm={(data) => handleDeleteAccount(data)}
            // onConfirm={handleDeleteAccount}
            onClose={() => setIsDeleteModalOpen(false)}
            deleteDate="12.04.25 | 20:00"
          />
        </div>
      </div>
    </>
  );
};
